import { InstallationSmartLockStatus } from "@/model/data/oneTimeCode/InstallationSmartLockStatus";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class FetchInstallationsSmartLockStatusResData extends ApiGenericResponse {
    installationsList: InstallationSmartLockStatus[];
    totalInstallationsCount: number;

    constructor(response: AxiosResponse) {
        super(response);
        this.installationsList = [];
        this.totalInstallationsCount = 0;
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList && obj.InstallationsList.length > 0) {
            obj.InstallationsList.forEach((e) => {
                let inst = new InstallationSmartLockStatus();
                inst.parse(e);
                this.installationsList.push(inst);
            });
        }
        if (obj.TotalInstallationsCount) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
